import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Notification from '../Common/Notification';
import { actions } from '../../actions/accountActions';
import ForgotUsernameForm from './ForgotUsernameForm';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import LoginStyleWrapper from '../Common/LoginStyleWrapper/LoginStyleWrapper';
import './ForgotUsernamePage.scss';

export class ForgotUsernamePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            emailAddress: '',
            error: '',
            isLoading: false,
            isSubmitted: false,
            isFormValid: true
        };
    }

    updateState = (event) => {
        this.setState({ error: '' });
        return this.setState({ emailAddress: event.target.value });
    }

    getUsername = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.emailAddress.trim().length < 1 || this.state.emailAddress.indexOf('@') === -1) {
            this.setState({ isFormValid: false });
            return;
        }

        try {
            this.setState({ isLoading: true });
            await this.props.actions.forgotUserName(this.state.emailAddress)
            this.setState({ isSubmitted: true });
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (

            <LoginStyleWrapper>
                <div className="container">
                    <LoadingIndicator isLoading={this.state.isLoading}>
                        <ForgotUsernameForm
                            emailAddress={this.state.emailAddress}
                            onSubmit={this.getUsername}
                            onChange={this.updateState}
                            isSubmitted={this.state.isSubmitted}
                            isFormValid={this.state.isFormValid}
                        />
                    </LoadingIndicator>
                </div>
            </LoginStyleWrapper>
        );
    }

}

ForgotUsernamePage.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(ForgotUsernamePage);